// src/hooks/nationalities/useCreateNationalities.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createNationality } from "../../api/apiNationalities";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useCreateNationalities = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createNationalities, isPending } = useMutation({
        mutationFn: createNationality,
        onSuccess: (res) => {
            const message = res?.message || "Nationality created successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["nationalities"] });
            navigate("/nationalities");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to create nationality");
        },
    });

    return { createNationalities, isPending };
};

export default useCreateNationalities;